import React from 'react';

const SpriteSvg = () => {
	return (
		<svg width="0" height="0" className="hidden">
			<symbol
				viewBox="0 0 7 12"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				id="ka-menu-arrow"
			>
				<path
					d="M6 1L1 6l5 5"
					stroke="#8D9DB0"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				></path>
			</symbol>
			<symbol
				viewBox="0 0 16 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				id="ka-menu-balance"
			>
				<path
					d="M8.25 7.25v6m-3-2.821h6M15.5 3H4a3 3 0 0 0-3 3v5.5"
					stroke="#AFB0B3"
					strokeLinecap="round"
					strokeLinejoin="round"
				></path>
				<path
					d="M13.5 1l2 2-2 2M.5 17.5h12a3 3 0 0 0 3-3V9"
					stroke="#AFB0B3"
					strokeLinecap="round"
					strokeLinejoin="round"
				></path>
				<path
					d="M2.5 19.5l-2-2 2-2"
					stroke="#AFB0B3"
					strokeLinecap="round"
					strokeLinejoin="round"
				></path>
			</symbol>
			<symbol
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				id="ka-menu-billing"
			>
				<path
					d="M18.954 6.82h.244a1 1 0 0 1 1 1v8.988c0 .52-.38.93-.851.93H4.671c-.472 0-.851-.424-.851-.93V7.82a1 1 0 0 1 1-1h14.134z"
					fill="#99C7FF"
				></path>
				<path
					d="M2 8.253h20.22M2 9.095h20.22M2 9.904h20.22"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinejoin="round"
				></path>
				<path
					d="M6.176 15.009h1.618m3.499 0h4.853"
					stroke="#1676EE"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				></path>
				<path
					d="M2 15.938V6.097C2 5.484 2.499 5 3.13 5h17.757c.632 0 1.13.484 1.13 1.097v12.365c0 .613-.498 1.096-1.13 1.096H3.13c-.631 0-1.13-.483-1.13-1.096v-3.113"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				></path>
			</symbol>
			<symbol
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				id="ka-menu-campaign"
			>
				<path
					d="M10.544 20l-1.239-.036a1.755 1.755 0 0 1-1.627-1.23l-1.184-3.91-.296-.995-.074-.073 2.552.018.555 1.991.259.941 1.683 2.064c.425.488.037 1.248-.629 1.23z"
					fill="#99C7FF"
				></path>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M5.574 13.817a.6.6 0 0 1 .506-.245l2.71.1a.6.6 0 0 1 .55.42l.71 2.262 1.767 2.323a.599.599 0 0 1 .11.244 1.364 1.364 0 0 1-1.402 1.624h-.001l-1.247-.036a2.38 2.38 0 0 1-2.168-1.638l-1.615-4.497a.6.6 0 0 1 .08-.557zm1.349.987l1.32 3.672a1.179 1.179 0 0 0 1.086.834l1.233.036h.003a.18.18 0 0 0 .152-.06.166.166 0 0 0 .024-.04l-1.71-2.249a.6.6 0 0 1-.095-.183l-.615-1.958-1.398-.052z"
					fill="#1676EE"
				></path>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M21 11.242v.416c0 .308-.019.616-.056.905a14.816 14.816 0 0 1-.444 2.679 10.924 10.924 0 0 1-.314.995.872.872 0 0 0-.056.127l-.055.108c-.222.543-.481.996-.777 1.303l-.055.055-.111.108-.037.037c-.278.253-.574.38-.888.38-.222 0-.425-.073-.629-.181-.037-.018-.074-.037-.092-.073a.1.1 0 0 0-.02-.015c-.01-.005-.017-.01-.017-.021a.256.256 0 0 0-.037-.027c-.014-.01-.028-.018-.037-.027-.829-.69-1.49-2.367-1.79-4.497.949-.217 1.408-1.163 1.408-2.274 0-1.12-.616-1.758-1.484-2.124l.016-.154c.148-1.34.437-2.658.833-3.403.634-1.194 1.424-1.194 1.849-1.194 1.517.072 2.756 3.095 2.793 6.877z"
					fill="#99C7FF"
				></path>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M15.206 9.197a.6.6 0 0 1 .838-.132l.076.055c.445.32 1.319.945 1.319 2.21 0 .963-.506 1.776-1.23 2.256a.6.6 0 1 1-.663-1 1.5 1.5 0 0 0 .693-1.255c0-.64-.398-.93-.873-1.275a.6.6 0 0 1-.16-.859z"
					fill="#1676EE"
				></path>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M17.609 5.06c-.19.086-.455.28-.721.78-.34.638-.62 1.86-.766 3.186v.002a18.04 18.04 0 0 0 .018 4.098c.134 1.102.365 2.075.659 2.847.295.78.634 1.299.95 1.568a1.164 1.164 0 0 1 .068.048.736.736 0 0 1 .07.064l.008.008a.69.69 0 0 0 .312.092c.135 0 .29-.048.476-.216l.189-.185c.22-.23.441-.602.648-1.108a.597.597 0 0 1 .02-.046l.04-.075c.02-.054.04-.098.057-.13a10.6 10.6 0 0 0 .274-.864c0-.002 0-.005.002-.008v-.004c.005-.021.014-.064.03-.117a14.229 14.229 0 0 0 .406-2.514c.034-.262.05-.544.05-.829v-.413c-.017-1.834-.328-3.456-.796-4.607-.235-.577-.5-1.008-.763-1.29-.257-.275-.478-.371-.65-.383-.202 0-.385.007-.581.096zm.585-1.296h.042c.585.028 1.084.34 1.48.763.397.423.73.997.998 1.658.54 1.323.867 3.103.886 5.05v.422c0 .326-.02.654-.059.966a15.395 15.395 0 0 1-.453 2.738v.003c-.005.022-.014.069-.032.124-.092.325-.19.65-.31.963a.618.618 0 0 1-.041.09.598.598 0 0 1-.04.095l-.044.086c-.234.567-.525 1.088-.89 1.468l-.013.013-.203.198v.001a.51.51 0 0 1-.015.014c-.366.334-.8.537-1.293.537a1.91 1.91 0 0 1-.9-.245.74.74 0 0 1-.244-.175.583.583 0 0 1-.03-.03.76.76 0 0 1-.053-.041c-.544-.459-.975-1.2-1.303-2.063-.335-.883-.585-1.954-.729-3.131v-.007a19.25 19.25 0 0 1-.018-4.368c.149-1.35.446-2.766.898-3.616.37-.695.816-1.098 1.286-1.31.448-.204.86-.203 1.08-.203zm-1.038 14.835z"
					fill="#1676EE"
				></path>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M17.118 5.302c-.443.471-.94.841-1.39 1.176l-.021.015a20.53 20.53 0 0 1-3.723 2.175c-1.197.53-2.363.872-3.277.872h-2.59a.6.6 0 0 1 0-1.2h2.59c.664 0 1.647-.263 2.791-.77a19.33 19.33 0 0 0 3.498-2.044c.468-.348.886-.66 1.25-1.049l.009-.009.034-.035c.18-.185.419-.43.694-.627.3-.214.688-.406 1.162-.406.614 0 1.13.33 1.53.773.4.445.734 1.054 1.003 1.755.538 1.408.86 3.312.86 5.384v.188c-.029 2.463-.5 4.627-1.238 6.016-.364.686-.836 1.264-1.429 1.536-.653.3-1.337.18-1.931-.302a23.88 23.88 0 0 1-1.15-.97l-.153-.135c-.324-.287-.64-.567-.964-.834-.75-.617-1.486-1.114-2.288-1.36-1.48-.448-2.954-.573-4.564-.682H7.82a42.894 42.894 0 0 0-1.72-.079.6.6 0 1 1 .033-1.2c.544.015 1.22.044 1.77.082 1.608.109 3.205.239 4.83.731h.003c1.028.316 1.91.932 2.7 1.581.341.282.676.578.999.864l.15.133c.374.33.733.644 1.096.925l.011.009c.293.238.496.23.678.147.244-.112.557-.419.87-1.009.617-1.162 1.07-3.114 1.098-5.463v-.178c0-1.963-.307-3.716-.781-4.955-.238-.622-.506-1.084-.773-1.38-.268-.297-.485-.377-.639-.377-.136 0-.284.053-.465.183-.185.132-.356.308-.556.513l-.006.006z"
					fill="#1676EE"
				></path>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M4.762 9.54c-1.274 0-2.162.793-2.162 1.863v.137c.064.737.519 1.612 1.7 1.869h.88a7.174 7.174 0 0 1-.23-1.843c0-.835.2-1.522.422-2.026h-.61zm1.8 4.182a.6.6 0 0 1-.527.887H4.238a.6.6 0 0 1-.117-.011c-1.874-.372-2.63-1.82-2.72-2.986a.605.605 0 0 1-.001-.046v-.163c0-1.898 1.603-3.063 3.362-3.063h1.664a.6.6 0 0 1 .45.997m0 0l-.001.002a3.246 3.246 0 0 0-.346.56 3.809 3.809 0 0 0-.378 1.667c0 .722.111 1.276.218 1.642a3.63 3.63 0 0 0 .184.496l.009.017m0 0z"
					fill="#1676EE"
				></path>
			</symbol>
			<symbol
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				id="ka-menu-channels"
			>
				<path
					d="M17.552 4.91c-.292-.633-1.021-.9-1.63-.597-.609.304-.865 1.062-.574 1.695.292.633 1.022.9 1.63.597.609-.304.865-1.062.574-1.695z"
					fill="#99C7FF"
				></path>
				<circle
					cx="16.158"
					cy="4.75"
					r="1.75"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				></circle>
				<path
					d="M15.394 17.817c-.67-.09-1.282.401-1.368 1.097-.086.696.386 1.333 1.056 1.423.669.09 1.281-.402 1.367-1.098.087-.696-.386-1.333-1.055-1.422z"
					fill="#99C7FF"
				></path>
				<circle
					cx="15.383"
					cy="19.484"
					r="1.75"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				></circle>
				<path
					d="M19.763 13.462c.683-.508.84-1.496.351-2.207a1.484 1.484 0 0 0-2.122-.365c-.683.509-.84 1.497-.351 2.207.489.71 1.44.874 2.122.365z"
					fill="#99C7FF"
				></path>
				<circle
					cx="18.485"
					cy="11.729"
					r="1.75"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				></circle>
				<path
					d="M14.6 6.162l-1.455 1.281m-.331 8.647l1.466 1.8m2.35-6.264l-2.26-.195"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				></path>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M13.649 14.311c-1.127 2.873-4.28 4.252-7.043 3.08-2.762-1.171-4.088-4.45-2.962-7.323 1.127-2.873 4.28-4.252 7.043-3.08 2.762 1.171 4.089 4.45 2.962 7.323zm-2.324.883c-.27.686-1.022 1.016-1.682.736-.66-.28-.977-1.063-.708-1.75.27-.685 1.022-1.015 1.682-.735.66.28.977 1.063.708 1.75z"
					fill="#99C7FF"
				></path>
				<circle
					cx="8.25"
					cy="11.577"
					r="6.25"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				></circle>
			</symbol>
			<symbol
				viewBox="0 0 22 19"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				id="ka-menu-conversation"
			>
				<path
					d="M1.94 15.336l.459-2.704s-.923-1.663-.936-3.448c.228-4.277 4.02-7.186 8.2-6.476 2.464.418 6.11 3.573 4.204 8.583-1.674 4.4-7.535 4.025-8.269 3.405l-3.452.833a.169.169 0 0 1-.207-.193zm14.556-.224c-1.963.688-2.349.86-4.123.003 3.62-1.842 4.34-5.946 4.123-9.615 0 0 2.145 1.059 2.755 5.012.359 2.321-1.041 3.385-1.041 3.385l.268 1.49a.188.188 0 0 1-.235.214l-1.747-.489z"
					fill="#99C7FF"
				></path>
				<path
					d="M15.032 9.088a7 7 0 0 1-9.453 5.447c-.393.062-2.32.662-3.233.95a.3.3 0 0 1-.386-.344c.158-.818.461-2.414.544-2.947a7 7 0 1 1 12.528-3.106z"
					stroke="#1676EE"
					strokeWidth="1.2"
				></path>
				<path
					d="M12.772 15.56a4.7 4.7 0 0 0 3.81.134c.33.153 1.519.532 2.192.742a.299.299 0 0 0 .382-.341c-.118-.63-.317-1.7-.392-2.179.765-1.113 1.124-2.556.893-4.054C19.385 8.102 18.36 6.66 17 5.87"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
				></path>
			</symbol>
			<symbol
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				id="ka-menu-dashboard"
			>
				<path
					d="M6.212 18.473h-2.74c-.255 0-.462-.195-.462-.434V15.24c0-.24.207-.434.462-.434h2.74c.254 0 .461.194.461.434v2.798c.016.224-.19.434-.461.434zm6.625-.002h-1.958a.465.465 0 0 1-.478-.448v-6.51c0-.254.223-.448.478-.448h1.958c.27 0 .478.209.478.448v6.51c0 .239-.207.448-.478.448zm7.169.003H17.62c-.271 0-.494-.21-.494-.464V6.308c0-.254.223-.464.494-.464h2.387c.271 0 .494.21.494.464V18.01c0 .254-.223.464-.494.464z"
					fill="#99C7FF"
				></path>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M6.496 19H3.504C3.229 19 3 18.787 3 18.532v-3.064c0-.255.229-.468.504-.468h2.992c.274 0 .503.213.503.468v3.064c.016.255-.213.468-.503.468z"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				></path>
				<path
					d="M10 17.553v-6.06c0-.269.229-.493.504-.493h2.992c.275 0 .504.224.504.493v7.013c0 .27-.229.494-.504.494h-2.992a.503.503 0 0 1-.504-.494v-.747"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				></path>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M20.527 5a.51.51 0 0 1 .473.496v13.008c0 .27-.229.496-.504.496h-2.992a.504.504 0 0 1-.504-.496V5.496c0-.27.229-.496.504-.496h3.023z"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				></path>
			</symbol>
			<symbol
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				id="ka-menu-developers"
			>
				<path
					d="M20.633 7H22v11.892c0 .62-.417 1.108-.935 1.108H4.435c-.518 0-.935-.505-.935-1.108V7h17.133z"
					fill="#99C7FF"
				></path>
				<path
					d="M2.222 6.631h19"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				></path>
				<path
					d="M4.076 5.768a.479.479 0 0 0 .484-.473.479.479 0 0 0-.484-.472.479.479 0 0 0-.485.472.48.48 0 0 0 .485.473zm1.619 0a.479.479 0 0 0 .485-.473.479.479 0 0 0-.485-.472.479.479 0 0 0-.484.472c0 .261.217.473.484.473zm1.62 0a.479.479 0 0 0 .484-.473.479.479 0 0 0-.484-.472.479.479 0 0 0-.484.472c0 .261.217.473.484.473z"
					fill="#99C7FF"
				></path>
				<path
					d="M9.644 15.583l-1.945-2.27 1.945-2.27m4.91 4.54l1.945-2.27-1.945-2.27m-1.605-.054l-1.7 4.752"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				></path>
				<path
					d="M2 16.255V5.135C2 4.5 2.458 4 3.039 4h17.922C21.541 4 22 4.5 22 5.135v13.73C22 19.5 21.542 20 20.961 20H3.039C2.459 20 2 19.5 2 18.866v-3.22"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				></path>
			</symbol>
			<symbol
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				id="ka-menu-directory"
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M21 13.044a8.925 8.925 0 1 1-17.85 0 8.925 8.925 0 0 1 17.85 0zM9.686 11.29c.22.425.563.785.982 1.032-.098.035-.2.075-.304.118-1.26.515-2.795 2.373-2.931 3.292a1.361 1.361 0 0 0 .424 1.216h8.441s.518-.347.423-1.216c-.066-.612-1.45-2.802-2.922-3.292-.158-.053-.308-.1-.45-.143a2.606 2.606 0 0 0 1.239-2.217 2.621 2.621 0 0 0-2.602-2.602 2.602 2.602 0 0 0-2.602 2.602c0 .424.09.847.302 1.21z"
					fill="#99C7FF"
				></path>
				<circle
					cx="11.698"
					cy="10.323"
					r="2.573"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				></circle>
				<path
					d="M13.479 12.5c2.375.792 2.922 3.167 2.922 3.293a.84.84 0 0 1-.006.097c-.089.732-.878 1.118-1.616 1.118H8.734c-.737 0-1.526-.386-1.615-1.118a.815.815 0 0 1-.006-.097c0-1.115 1.305-2.353 2.93-3.293"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				></path>
				<circle
					cx="11.5"
					cy="12.5"
					r="9.5"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				></circle>
			</symbol>
			<symbol
				viewBox="0 0 12 8"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				id="ka-paginate-down"
			>
				<path
					d="M1.41.59L6 5.17 10.59.59 12 2 6 8 0 2 1.41.59z"
					fill="#1676EE"
				></path>
			</symbol>
			<symbol
				viewBox="0 0 11 6"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				id="ka-profile-dropdown"
			>
				<path
					d="M4.172 2h2.656L5.5 3.328 4.172 2z"
					stroke="#5F6368"
					strokeWidth="3"
				></path>
			</symbol>
			<symbol
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				id="ka-menu-flow-builder"
			>
				<path
					d="M14.5 9.75v-4a.5.5 0 0 0-.5-.5H6a1.5 1.5 0 0 0-1.5 1.5v3h10z"
					fill="#99C7FF"
				></path>
				<path
					d="M12.247 4h-.342m1.027 0h.568A1.5 1.5 0 0 1 15 5.5v3a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 3 8.5v-3A1.5 1.5 0 0 1 4.5 4h8.605M6.167 15.116h3.546"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				></path>
				<path
					d="M11.313 12.75v3.55a.5.5 0 0 0 .5.5H21.5a.5.5 0 0 0 .5-.5v-3.55H11.313z"
					fill="#99C7FF"
				></path>
				<path
					d="M11.552 17.75H20.5a1.5 1.5 0 0 0 1.5-1.5v-1.872a1.5 1.5 0 0 0-1.5-1.5h-9a1.5 1.5 0 0 0-1.5 1.5v1.872a1.5 1.5 0 0 0 1.5 1.5h.041m1.541 0h-.513M5.665 10v9"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				></path>
			</symbol>
			<symbol
				viewBox="0 0 56 56"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				id="ka-menu-Logo-Small"
			>
				<path
					d="M34.471 6.938L27.651 3l-6.822 3.938v7.226l6.822-3.938 6.822 3.94-.002-7.228zM20.829 49.062L27.653 53l6.82-3.938v-7.226l-6.82 3.938-6.824-3.94v7.228zM6 15.506v7.879l6.258 3.612V19.12l6.823-3.938-6.258-3.613L6 15.506zM6 32.63v7.877l6.822 3.939 6.259-3.613-6.824-3.938.002-7.879L6 32.63zm36.479 11.816l6.824-3.938v-7.879l-6.26-3.613v7.879l-6.824 3.938 6.26 3.613zM36.22 15.18l6.823 3.94v7.877l6.26-3.614v-7.877l-6.824-3.938-6.26 3.613z"
					fill="#999"
				></path>
				<path
					d="M36.136 32.752l-8.486 5.193-8.484-5.193v-9.504l8.484-5.193 8.486 5.193v9.504z"
					fill="#DB1E3C"
				></path>
			</symbol>
			<symbol
				viewBox="0 0 170 56"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				id="ka-menu-Logo-text"
			>
				<path
					d="M26.594 40.638l-7.054-10.77-2.602 2.406v8.364H10V11.224L16.938 8v16.072l9.367-8.624h9.713L25.032 25.713l9.657 14.925h-8.095zm35.886 0v-29.25L69.477 8v32.638H62.48zm26.966-18.296c-1.1-1.038-2.372-1.53-3.932-1.53a6.024 6.024 0 0 0-4.048 1.48c-1.155 1.04-1.734 2.243-1.734 3.718h11.275a4.81 4.81 0 0 0-1.561-3.663v-.005zm-9.656 8.851c-.058.931.463 1.75 1.503 2.515.925.657 1.85 1.094 2.833 1.259a15.05 15.05 0 0 0 1.678.108c.751 0 1.56-.217 2.543-.6.984-.438 1.735-.93 2.14-1.532l5.03 3.498c-1.098 1.313-2.544 2.351-4.336 3.17a13.231 13.231 0 0 1-5.436 1.204c-3.932 0-7.112-1.148-9.482-3.39-2.371-2.296-3.585-5.302-3.585-9.075 0-4.047 1.156-7.217 3.47-9.569 2.313-2.35 5.55-3.497 9.77-3.497 4.106 0 7.344 1.641 9.598 4.977 1.615 2.405 2.43 6.068 2.43 10.934l-18.156-.002zM51.813 33.01c0 .798-1.626 2.033-4.4 2.033-3.644 0-5.368-1.147-5.368-3.443 0-1.5 1.28-2.88 5.028-2.88h4.74v4.29zm3.355-15.662c-2.024-1.367-4.633-1.978-7.811-1.927l-4.473.034-2.33 5.826h5.939c4.318 0 5.319.666 5.319 3.075 0 0-3.354-.27-5.61-.27-3.178 0-5.784.656-7.687 2.019-2.2 1.53-3.24 3.17-3.24 6.068 0 2.678.808 4.811 2.487 6.287 1.678 1.476 3.932 2.241 6.764 2.241 6.204 0 7.307-.942 7.307-.942l.492.883h6.311v-16.68c0-2.898-1.157-5.084-3.47-6.616m87-1.913h-4.843a10.337 10.337 0 0 0-5.373 1.448v-1.426h-6.954v25.184h6.954V28.983c0-5.6.606-7.772 5.958-7.772h1.893l2.365-5.778zM101.8 48h7.557l13.263-32.552h-7.554l-4.859 11.983-4.879-11.983h-7.523l8.621 21.165L101.8 48zm52.673-14.99c0 .798-1.627 2.033-4.402 2.033-3.642 0-5.367-1.147-5.367-3.443 0-1.5 1.279-2.88 5.028-2.88h4.741v4.29zm3.353-15.662c-2.018-1.367-4.631-1.978-7.811-1.927l-4.439.027-2.364 5.826h5.945c4.319 0 5.32.666 5.32 3.075 0 0-3.355-.269-5.61-.269-3.18 0-5.784.655-7.689 2.018-2.199 1.53-3.237 3.17-3.237 6.068 0 2.678.807 4.812 2.484 6.287 1.678 1.476 3.933 2.241 6.766 2.241 6.203 0 7.306-.941 7.306-.941l.491.775h6.313V23.963c0-2.897-1.157-5.083-3.471-6.616"
					fill="#999"
				></path>
			</symbol>
			<symbol
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				id="ka-menu-market-place"
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M14.5 19.745h4.167v-8.168l-1.885-.947-2.418.947-2.418-.947-2.493.947-2.493-.947-2.46.947v8.168h5v-4.471a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4.472z"
					fill="#99C7FF"
				></path>
				<path
					d="M9.5 19.746v-4.473a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4.473h-5z"
					stroke="#1676EE"
					strokeWidth="1.2"
				></path>
				<path
					d="M19.843 12.016V18.5a1.5 1.5 0 0 1-1.5 1.5H5.824a1.5 1.5 0 0 1-1.5-1.5v-6.484"
					stroke="#1676EE"
					strokeWidth="1.2"
				></path>
				<path
					d="M19.344 4H4.904l-2.07 3.786.299.732c.662 1.62 2.848 1.876 3.867.454l.842.559a3 3 0 0 0 3.316 0L12 8.972l.842.559a3 3 0 0 0 3.316 0L17 8.972c1.087 1.423 3.315 1.093 3.942-.585l.225-.601L19.344 4z"
					fill="#99C7FF"
				></path>
				<path
					d="M18.823 4H5.383a.796.796 0 0 0-.703.421L2.685 8.16a2.58 2.58 0 0 0 .06 2.535c.902 1.512 3.059 1.604 4.085.172l.09-.126a.141.141 0 0 1 .194-.035l.728.483a3 3 0 0 0 3.316 0l.566-.375a.5.5 0 0 1 .552 0l.566.375a3 3 0 0 0 3.316 0l.729-.483a.146.146 0 0 1 .196.033l.141.185c1.076 1.409 3.243 1.255 4.11-.291a2.602 2.602 0 0 0 .069-2.414l-1.83-3.75a.835.835 0 0 0-.75-.468z"
					stroke="#1676EE"
					strokeWidth="1.2"
				></path>
			</symbol>
			<symbol
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				id="ka-menu-numbers"
			>
				<circle cx="4.519" cy="6.387" r="1.519" fill="#99C7FF"></circle>
				<circle
					cx="5"
					cy="6"
					r="2"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				></circle>
				<circle
					cx="11.189"
					cy="6.387"
					r="1.519"
					fill="#99C7FF"
				></circle>
				<circle
					cx="11.5"
					cy="6"
					r="2"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				></circle>
				<circle cx="17.86" cy="6.387" r="1.519" fill="#99C7FF"></circle>
				<circle
					cx="18"
					cy="6"
					r="2"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				></circle>
				<circle
					cx="4.519"
					cy="12.887"
					r="1.519"
					fill="#99C7FF"
				></circle>
				<circle
					cx="5"
					cy="12.5"
					r="2"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				></circle>
				<circle
					cx="11.189"
					cy="12.887"
					r="1.519"
					fill="#99C7FF"
				></circle>
				<circle
					cx="11.5"
					cy="12.5"
					r="2"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				></circle>
				<circle
					cx="17.86"
					cy="12.887"
					r="1.519"
					fill="#99C7FF"
				></circle>
				<circle
					cx="18"
					cy="12.5"
					r="2"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				></circle>
				<circle
					cx="11.189"
					cy="19.387"
					r="1.519"
					fill="#99C7FF"
				></circle>
				<circle
					cx="11.5"
					cy="19"
					r="2"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				></circle>
			</symbol>
			<symbol
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				id="ka-menu-verify"
			>
				<path
					d="M13.075 2.604L6.33 5.164a1 1 0 0 0-.645.934v5.921c.416 4.518 3.467 7.191 5.856 9.11a.99.99 0 0 0 1.148.066c5.257-3.315 6.841-5.314 6.841-10.148V5.272a1 1 0 0 0-.678-.946l-5.099-1.734a1 1 0 0 0-.677.012z"
					fill="#99C7FF"
				></path>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M12.115 2.661a.4.4 0 0 0-.23 0l-7 2.103a.4.4 0 0 0-.285.383v6.155c0 6.079 4.51 8.591 7.17 9.915.12.06.268.054.387-.02 2.85-1.766 4.632-2.949 5.73-4.331 1.059-1.335 1.513-2.907 1.513-5.564V5.147a.4.4 0 0 0-.285-.383l-7-2.103zm-.575-1.15c.3-.09.62-.09.92 0l7 2.104a1.6 1.6 0 0 1 1.14 1.532v6.155c0 2.804-.482 4.683-1.773 6.31-1.253 1.578-3.234 2.868-6.038 4.605a1.6 1.6 0 0 1-1.553.075C8.557 20.959 3.4 18.15 3.4 11.302V5.147a1.6 1.6 0 0 1 1.14-1.532l7-2.103z"
					fill="#1676EE"
				></path>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M16.805 8.39a.6.6 0 0 1 .005.849l-4.825 4.882a.6.6 0 0 1-.853 0l-2.085-2.109a.6.6 0 0 1 .854-.843l1.657 1.677 4.399-4.45a.6.6 0 0 1 .848-.006z"
					fill="#1676EE"
				></path>
			</symbol>
			<symbol
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 100 100"
				preserveAspectRatio="xMidYMid"
				display="block"
				id="Rolling-1s-200px (1)"
			>
				<circle
					cx="50"
					cy="50"
					fill="none"
					stroke="#6aa4eb"
					strokeWidth="8"
					r="40"
					strokeDasharray="188.49555921538757 64.83185307179586"
					transform="rotate(342.246 50 50)"
				>
					<animateTransform
						attributeName="transform"
						type="rotate"
						repeatCount="indefinite"
						dur="0.9615384615384615s"
						values="0 50 50;360 50 50"
						keyTimes="0;1"
					></animateTransform>
				</circle>
			</symbol>
			<symbol
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 18 21"
				id="ka-menu-chatbot"
			>
				<path
					d="M16.721 17.969a.318.318 0 00.544-.225V5.189a1.271 1.271 0 00-1.268-1.272H3.941A1.271 1.271 0 002.67 5.19v8.767a1.275 1.275 0 001.264 1.271l10.102.046 2.685 2.696z"
					fill="#6AA4EB"
					fillOpacity=".4"
				></path>
				<path
					d="M16.44 19.345a.349.349 0 00.6-.244V5.226a1.406 1.406 0 00-1.402-1.402H2.325A1.406 1.406 0 00.923 5.226v9.69a1.402 1.402 0 001.395 1.403l11.156.056 2.966 2.97z"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				></path>
				<path
					d="M9 1.731a.75.75 0 100-1.5.75.75 0 000 1.5zM5.813 9.438a.75.75 0 01-1.5 0V7.562a.75.75 0 011.5 0v1.875zm7.5 0a.75.75 0 11-1.5 0V7.562a.75.75 0 111.5 0v1.875z"
					fill="#1676EE"
				></path>
				<path
					d="M9 .813v2.625"
					stroke="#1676EE"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				></path>
			</symbol>
			<symbol
				width="24"
				height="24"
				id="ka-menu-urlShortener"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M20.6331 7.00013C21.3813 7.00013 21.5577 7.00012 22 7.00012V9.87201V18.8923C22 19.5114 21.5827 20.0001 21.0647 20.0001L4.43525 20.0001C3.91727 20.0001 3.5 19.495 3.5 18.8922V7.00006L20.6331 7.00013Z"
					fill="#99C7FF"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M1.62158 6.63128C1.62158 6.29991 1.89021 6.03128 2.22158 6.03128H21.2216C21.553 6.03128 21.8216 6.29991 21.8216 6.63128C21.8216 6.96265 21.553 7.23128 21.2216 7.23128H2.22158C1.89021 7.23128 1.62158 6.96265 1.62158 6.63128Z"
					fill="#1676EE"
				/>
				<path
					d="M12.1079 14.1469C11.8051 14.3972 11.4261 14.5217 11.0424 14.4969C10.6587 14.4721 10.2968 14.2997 10.0252 14.0124L8.47061 12.37C8.32157 12.215 8.2032 12.0302 8.1224 11.8263C8.04161 11.6225 8 11.4037 8 11.1828C8 10.9618 8.04161 10.743 8.1224 10.5392C8.2032 10.3354 8.32157 10.1506 8.47061 9.99552V9.99552C8.61762 9.83853 8.79263 9.71391 8.98552 9.62885C9.17842 9.54379 9.38536 9.5 9.59438 9.5C9.8034 9.5 10.0104 9.54379 10.2032 9.62885C10.3961 9.71391 10.5712 9.83853 10.7182 9.99552L10.9055 10.1974"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M11.4561 12.6285C11.7602 12.4007 12.1362 12.2901 12.5153 12.3169C12.8943 12.3437 13.251 12.5062 13.52 12.7746L15.0709 14.3291C15.218 14.475 15.3347 14.6486 15.4144 14.8399C15.4941 15.0311 15.5352 15.2363 15.5352 15.4435C15.5352 15.6507 15.4941 15.8559 15.4144 16.0471C15.3347 16.2384 15.218 16.412 15.0709 16.5579V16.5579C14.9241 16.707 14.7492 16.8253 14.5562 16.9061C14.3633 16.9869 14.1562 17.0285 13.9471 17.0285C13.7379 17.0285 13.5308 16.9869 13.3379 16.9061C13.145 16.8253 12.9701 16.707 12.8233 16.5579L12.5499 16.2845"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M3.03886 4.60012C2.83824 4.60012 2.5999 4.78123 2.5999 5.13463V18.8656C2.5999 19.219 2.83824 19.4001 3.03886 19.4001H20.9609C21.1616 19.4001 21.3999 19.219 21.3999 18.8656V5.13463C21.3999 4.78122 21.1616 4.60012 20.9609 4.60012H3.03886ZM1.3999 18.8656C1.3999 19.7802 2.0783 20.6001 3.03886 20.6001H20.9609C21.9215 20.6001 22.5999 19.7802 22.5999 18.8656V5.13463C22.5999 4.22005 21.9215 3.40012 20.9609 3.40012H3.03886C2.0783 3.40012 1.3999 4.22005 1.3999 5.13463V18.8656Z"
					fill="#1676EE"
				/>
			</symbol>
			<symbol
				width="22"
				height="16"
				viewBox="0 0 22 16"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				id="ka-menu-subaccount"
			>
				<path
					d="M2.45776 15.4344V12.0525C2.39946 10.5365 3.50733 9.25368 5.02336 9.19537H11.0875C12.5452 9.31199 13.6531 10.5365 13.5948 11.9942V15.4344"
					fill="#99C7FF"
				/>
				<path
					d="M10.0963 2.08152C9.92136 1.84829 9.74643 1.61505 9.51319 1.38182C9.27996 1.20689 9.04672 1.03196 8.81348 0.857036C8.58025 0.740418 8.2887 0.6238 8.05547 0.565491H7.99716C6.53943 0.565491 5.31494 2.08153 5.31494 3.94741C5.31494 5.8133 6.53943 7.32934 7.99716 7.32934H8.05547C8.69687 7.15441 9.27996 6.80456 9.74643 6.27978C9.97966 6.04654 10.1546 5.75499 10.2712 5.46345C10.3878 5.1719 10.5044 4.93867 10.6211 4.70543C10.6794 4.41389 10.6794 4.18065 10.6794 3.88911C10.6794 3.36433 10.5628 2.89785 10.3878 2.43138C10.3295 2.43138 10.2129 2.25645 10.0963 2.08152Z"
					fill="#99C7FF"
				/>
				<path
					d="M7.29745 7.44596C9.16524 7.44596 10.6794 5.93182 10.6794 4.06404C10.6794 2.19625 9.16524 0.682114 7.29745 0.682114C5.42967 0.682114 3.91553 2.19625 3.91553 4.06404C3.91553 5.93182 5.42967 7.44596 7.29745 7.44596Z"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
				/>
				<path
					d="M17.6739 2.89655C17.5761 2.75862 17.4783 2.62069 17.3478 2.48276C17.2174 2.37931 17.087 2.27586 16.9565 2.17241C16.8261 2.10345 16.663 2.03448 16.5326 2H16.5C15.6848 2 15 2.89655 15 4C15 5.10345 15.6848 6 16.5 6H16.5326C16.8913 5.89655 17.2174 5.68966 17.4783 5.37931C17.6087 5.24138 17.7065 5.06896 17.7717 4.89655C17.837 4.72414 17.9022 4.58621 17.9674 4.44828C18 4.27586 18 4.13793 18 3.96552C18 3.65517 17.9348 3.37931 17.837 3.10345C17.8043 3.10345 17.7391 3 17.6739 2.89655Z"
					fill="#99C7FF"
				/>
				<path
					d="M15.6938 6.44189C16.9175 6.44189 17.9095 5.44987 17.9095 4.22615C17.9095 3.00243 16.9175 2.01041 15.6938 2.01041C14.47 2.01041 13.478 3.00243 13.478 4.22615C13.478 5.44987 14.47 6.44189 15.6938 6.44189Z"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
				/>
				<path
					d="M1 14.8514V12.0525C1 10.4782 2.2828 9.19537 3.85714 9.19537H10.6793C12.2536 9.19537 13.4781 10.4782 13.4781 11.9942V14.8514"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
				/>
				<path
					d="M15 9.5C15 8.67157 15.6716 8 16.5 8H19C20.1046 8 21 8.89543 21 10V13H15V9.5Z"
					fill="#99C7FF"
				/>
				<path
					d="M20.9999 12.6354V11.0027C20.9999 9.37007 19.6588 7.97066 18.0261 7.97066H14.1777"
					stroke="#1676EE"
					strokeWidth="1.2"
					strokeLinecap="round"
				/>
			</symbol>
			<symbol
				id="ka-menu-failover"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M10.6574 4.68327C10.9951 4.68327 11.0747 4.68327 11.2744 4.68327V5.97963V10.0514C11.2744 10.3308 11.086 10.5514 10.8522 10.5514L3.34569 10.5514C3.11188 10.5514 2.92352 10.3234 2.92352 10.0513V4.68324L10.6574 4.68327Z"
					fill="#99C7FF"
				/>
				<rect
					x="2"
					y="3"
					width="9.54523"
					height="7.82227"
					rx="1"
					stroke="#1676EE"
					strokeLinecap="round"
				/>
				<path
					d="M2.08569 4.70532H11.4624"
					stroke="#1676EE"
					strokeLinecap="round"
				/>
				<path
					d="M22.0877 15.0352C22.4255 15.0352 22.5051 15.0352 22.7047 15.0352V16.3316V20.4033C22.7047 20.6827 22.5164 20.9034 22.2826 20.9034L14.7761 20.9033C14.5422 20.9033 14.3539 20.6754 14.3539 20.4033V15.0352L22.0877 15.0352Z"
					fill="#99C7FF"
				/>
				<rect
					x="13"
					y="13"
					width="9.54523"
					height="7.82227"
					rx="1"
					stroke="#1676EE"
					strokeLinecap="round"
				/>
				<path
					d="M13.0857 14.7053H22.4624"
					stroke="#1676EE"
					strokeLinecap="round"
				/>
				<path
					d="M15.4059 5.86179H19.3368C19.8891 5.86179 20.3368 6.3095 20.3368 6.86179V9.63597"
					stroke="#1676EE"
					strokeLinecap="round"
				/>
				<path
					d="M15.9756 4.24594L14.7231 5.49845C14.5864 5.63514 14.5864 5.85675 14.7231 5.99343L15.9756 7.24594"
					stroke="#1676EE"
					strokeLinecap="round"
				/>
				<path
					d="M9.40643 18.0201L5.47557 18.0201C4.92328 18.0201 4.47557 17.5724 4.47557 17.0201L4.47557 14.2459"
					stroke="#1676EE"
					strokeLinecap="round"
				/>
				<path
					d="M8.83679 19.636L10.0893 18.3835C10.226 18.2468 10.226 18.0252 10.0893 17.8885L8.83679 16.636"
					stroke="#1676EE"
					strokeLinecap="round"
				/>
			</symbol>
		</svg>
	);
};

export default SpriteSvg;